// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
.red .codeColumn {
    background-color: red;
}

.blue .codeColumn {
    background-color: blue;
}

.yellow .codeColumn {
    background-color: yellow;
}

.green .codeColumn {
    background-color: limegreen;
}


.dqoi-search-bar{
	margin-right:-26px;
}
*/
construction-quick-search {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/construction/construction-main/search/construction-search.component.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;CAAA;AAsBA;EACI,WAAA;AACJ","sourcesContent":["/*\n.red .codeColumn {\n    background-color: red;\n}\n\n.blue .codeColumn {\n    background-color: blue;\n}\n\n.yellow .codeColumn {\n    background-color: yellow;\n}\n\n.green .codeColumn {\n    background-color: limegreen;\n}\n\n\n.dqoi-search-bar{\n\tmargin-right:-26px;\n}\n*/\nconstruction-quick-search{\n    width:100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
